import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { BasicNodeModel, ComparisonNodeBaseModel } from '..';
import { ContractComparisonPanel } from '../../types';
import ComparisonInputGroupModel from './ComparisonInputGroupModel';

export default class BasicComparisonNodeModel extends ComparisonNodeBaseModel {
    groups: ComparisonInputGroupModel[] = [];

    constructor(
        nodeId: string,
        nodeName: string,
        predefinedPanels?: ContractComparisonPanel[],
        readonly newNode?: BasicNodeModel,
        readonly previousNode?: BasicNodeModel
    ) {
        super(nodeId, nodeName, predefinedPanels);

        makeObservable(this, {
            groups: observable.ref,
            initializeGroups: action,
            inputIds: computed
        });

        this.initializeGroups();

        this.reactions.push(
            reaction(
                () => this.inputIds,
                () => this.initializeGroups()
            )
        );
    }

    dispose() {
        super.dispose();
        this.groups.forEach(group => group.dispose());
    }

    initializeGroups() {
        this.groups.forEach(group => group.dispose());
        this.groups = this.panels.map(
            panel =>
                new ComparisonInputGroupModel(
                    panel.id,
                    panel.inputIds,
                    inputId => this.newNode?.getInputById(inputId),
                    inputId => this.previousNode?.getInputById(inputId)
                )
        );
    }

    get inputIds() {
        return this.getInputIds(this.newNode?.inputIds, this.previousNode?.inputIds);
    }
}
